import { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import Header from "../../components/Header/Header.js";
import { toast } from "react-toastify";
import Call_Api from "../../Common/Handileapi/Call_api";
import { path } from "../../routes/Paths";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";
import { checkCompareNames } from "../../Common/creditCardBinAPI/CommonFunctions";
import Cookies from "js-cookie";
import { WarningMsg } from "../../components/ReusebleComponents/ToastifyMessages";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import Loaders from "../../components/ReusebleComponents/Loaders.jsx";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import { ImagesPath } from "../../Common/imagespath/imagespath";
import {
  isFeatureActive,
  isFeatureServiceActive,
} from "../../Common/serviceActiveCheck/serviceActiveCheck.js";
import { data } from "../../Common/Text/NormalText.js";
import "../../styles/PayService.css";

export default function PayService() {
  const [searchTerm, setSearchTerm] = useState("");
  const [showInputs, setShowInputs] = useState(false);
  const [accountNumber, setAccountNumber] = useState("");
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [isIfscVerifying, setIsIfscVerifying] = useState(false);
  const [isIfscVerified, setIsIfscVerified] = useState(false);
  const [showBeneficiaryInput, setShowBeneficiaryInput] = useState(false);
  const [panNumber, setPanNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [showDetails, setShowDetails] = useState(null);
  const [savedContacts, setSavedContacts] = useState([]);
  const [panBeneficiaryName, setPanBeneficiaryName] = useState("");
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [accountError, setAccountError] = useState(null);
  const [contactId, setContactId] = useState("");
  const [fundAccountId, setFundAccountId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [preview, setPreview] = useState(false);
  const [panError, setPanError] = useState("");
  const [payLoading, setPayLoading] = useState(true);
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const [show, setshow] = useState(false);
  const [existingError, setExistingError] = useState("");
  const [detailsError, setDetailsError] = useState("");

  const date = new Date();
  const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric" };
  const optionsTime = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };
  const formattedDate = date.toLocaleDateString("en-GB", optionsDate);
  const navigate = useNavigate();

  const handleIfscChange = (e) => {
    setAccountError("");
    setDetailsError("");
    setShowBeneficiaryInput(false);
    const value = e.target.value.toUpperCase();
    setIfscCode(value);
    if (value.length === 11) {
      setIsIfscVerifying(true);
    } else {
      setIsIfscVerifying(false);
      setIsIfscVerified(false);
      setIsPanVerified(false);
      setPanBeneficiaryName("");
      setMobileNumber("");
      setPanNumber("");
    }
  };

  const userDetails = useSelector((state) => state.user.user);
  const features = useSelector((state) => state.activeFeatures.features);

  const handleIfsc = async () => {
    if (
      !ifscCode ||
      !accountNumber ||
      ifscCode?.length != 11 ||
      accountNumber?.length <= 9
    ) {
      setDetailsError("Give the Required Fields Properly");
      return;
    }
    setAccountError("");
    setIsLoading(true);
    if (isLoading) {
      return;
    }
    try {
      const response = await Call_Api(
        path.ACCOUNT_VERIFY,
        "POST",
        { account_no: accountNumber, ifsc: ifscCode },
        token
      );

      console.log("response in handle ifsc", response);
      if (response?.success) {
        if (response?.response?.message?.toLowerCase() === "invalid") {
          console.log("invalid");
          setAccountError(`Account Number or Ifsc is Invalid, Please Recheck`);
          return;
        }
        const userName = response?.response?.beneficiaryName;
        if (
          userName == "" ||
          userName == null ||
          userName == undefined ||
          userName == "Name Not Found"
        ) {
          setAccountError(response?.response?.responseMsg);
          setIsIfscVerified(false);
          setIsIfscVerifying(false);
          return;
        } else {
          setShowBeneficiaryInput(true);
          setIsIfscVerified(true);
          setIsIfscVerifying(false);
          setBeneficiaryName(userName?.toUpperCase());
          addBeneficiaryRazorPay(userName?.toUpperCase());
        }
      } else {
        console.log("error while Verifying");
        setIsIfscVerified(false);
        setIsIfscVerifying(false);
        setAccountError(response?.response?.responseMsg);
      }
    } catch (error) {
      setAccountError("Internal Server Error Please Try again");
      console.log("error while sending data===>", error);
    } finally {
      setIsLoading(false);
    }
  };

  const addBeneficiaryRazorPay = async (beneficiaryName) => {
    const formattedTime = date.toLocaleTimeString("en-US", optionsTime);
    try {
      const headers = {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Authorization: `Bearer ${token}`,
      };
      const detailsToSendBackEnd = {
        beneficiaryName: beneficiaryName, // Use the passed beneficiaryName here
        beneficiaryIfscCode: ifscCode,
        beneficiaryAccountNumber: accountNumber,
        createdDate: formattedDate,
        createdTime: formattedTime,
      };
      const response = await Call_Api(
        "/createpayoutRazorPay/bendetails",
        "POST",
        detailsToSendBackEnd,
        token
      );

      console.log(
        "response after adding beneficiary in razorpay===>",
        response
      );
      if (response?.success) {
        setContactId(response?.response?.contactId);
        setFundAccountId(response?.response?.fundAccountId);
      }
    } catch (error) {
      console.log(
        "error while adding beneficiary in razorpay===>",
        error?.response?.data
      );
    }
  };

  const handleBeneficiaryChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (/^[A-Z\s]*$/.test(value)) {
      setBeneficiaryName(value);
    }
  };

  const handlePanNumberChange = (e) => {
    setPanError("");
    const value = e.target.value.toUpperCase();
    if (/^[A-Z0-9]*$/.test(value) && value.length <= 10) {
      setPanNumber(value);
    } else {
      toast.warning("Check Your Pan Number");
    }
    setIsPanVerified(false);
    setPanBeneficiaryName(false);
  };

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    setMobileNumber(value);
  };

  const handleMessage = (value) => {
    if (!/^[6-9]\d{0,9}$/.test(value) && value?.length > 5) {
      return "Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9";
    }
  };

  const handlePanVerify = async () => {
    try {
      setIsLoading(true);
      const response = await Call_Api(
        path.PAN_VERIFY,
        "POST",
        { panNumber: panNumber },
        token
      );
      console.log("response after sending details===>", response);
      if (response?.success) {
        console.log(
          response?.response?.response?.beneficiaryName ||
            response?.response?.beneficiaryName
        );
        const result = await checkCompareNames(
          response?.response?.response?.beneficiaryName ||
            response?.response?.beneficiaryName,
          beneficiaryName
        );
        if (result) {
          setPanBeneficiaryName(
            response?.response?.response?.beneficiaryName ||
              response?.response?.beneficiaryName
          );
          setIsPanVerified(true);
        } else {
          setPanError(
            "The account beneficiary name must match the name on the PAN"
          );
        }
      } else {
        setPanError(response?.message);
      }
    } catch (error) {
      setPanError("Pan Verification Failed, Please Try again later");
      console.log("error while sending data===>", error?.response);
    } finally {
      setIsLoading(false);
    }
  };

  const location = useLocation();
  useEffect(() => {
    getAllPays();
  }, [location?.state]);

  const handleProceed = async (value) => {
    console.log("value===>>", value);
    if (addLoading) return;
    if (value == "Confirm") {
      if (
        accountNumber.length >= 10 &&
        ifscCode.length === 11 &&
        beneficiaryName &&
        mobileNumber.length === 10 &&
        isIfscVerified
      ) {
        const payOutDetails = {
          payOutName: beneficiaryName,
          MerchantId: userDetails ? userDetails?.MerchantId : "",
          payOutMobileNumber: mobileNumber,
          mobileNumber: userDetails ? userDetails?.mobileNumber : "",
          payOutPanName: panBeneficiaryName,
          payOutPanNumber: panNumber,
          payOutAccountNumber: accountNumber,
          payOutIFSCNumber: ifscCode,
          payOutFundAccountId: fundAccountId,
          payOutContactId: contactId,
          payOutActiveStatus: "Active",
          payOutAccountHolderName: beneficiaryName,
          serviceName: "PayOut_Settlements",
        };
        setAddLoading(true);
        try {
          const response = await Call_Api(
            path.SAVE_PAYOUT_DATA,
            "POST",
            payOutDetails,
            token
          );

          console.log("response after saving clinet information===>", response);

          if (response?.success) {
            if (response?.response?.message === "Existing") {
              setExistingError("It is a Existing Payee");
            } else {
              await getAllPays();
            }
          } else {
            console.log("Error in adding payee");
          }
        } catch (error) {
          console.log("error while saving client information===>", error);
        } finally {
          setAddLoading(false);
        }
      } else {
        await WarningMsg(
          "Verification not yet done or fields does not have correct values"
        );
      }
    } else {
      setshow(false);
      setShowInputs(false);
      setPreview(false);
      setMobileNumber("");
      setBeneficiaryName("");
      setIfscCode("");
      setAccountNumber("");
      setPanNumber("");
      setPanBeneficiaryName("");
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (!value) {
      setFilteredContacts(savedContacts);
      return;
    }

    const result = savedContacts.filter((detail) => {
      return (
        detail?.payOutAccountNumber?.includes(value) ||
        detail?.payOutName?.toLowerCase()?.includes(value?.toLowerCase())
      );
    });

    console.log(result, "result");

    if (result?.length > 0) {
      setFilteredContacts(result);
    } else {
      setFilteredContacts([]);
    }
  };

  const getAllPays = async () => {
    try {
      const payOutResponse = await Call_Api(
        path.GET_ALL_PAYS("PayOut_Settlements"),
        "GET",
        {},
        token
      );
      console.log({ payOutResponse });
      if (payOutResponse?.success) {
        console.log("get app", payOutResponse?.response?.payOutDetails);
        // Reset all form states
        setShowInputs(false);
        setShowDetails(false);
        setshow(false);
        setAccountNumber("");
        setIfscCode("");
        setBeneficiaryName("");
        setMobileNumber("");
        setPanNumber("");
        setIsIfscVerified(false);
        setIsIfscVerifying(false);
        setShowBeneficiaryInput(false);
        setIsPanVerified(false);
        setPanBeneficiaryName("");
        setContactId("");
        setFundAccountId("");
        const updatedList = payOutResponse?.response?.payOutDetails || [];
        setSavedContacts(updatedList);
        if (searchTerm) {
          const filtered = updatedList.filter(
            (detail) =>
              detail?.payOutAccountNumber?.includes(searchTerm) ||
              detail?.payOutName
                ?.toLowerCase()
                ?.includes(searchTerm.toLowerCase())
          );
          setFilteredContacts(filtered);
        } else {
          setFilteredContacts(updatedList);
        }
      }
    } catch (error) {
      console.log("error while saving client information===>", error);
    } finally {
      setPayLoading(false);
    }
  };

  const handleShowDetail = (details) => {
    setMobileNumber(details?.payOutMobileNumber);
    setBeneficiaryName(details?.payOutName);
    setAccountNumber(details?.payOutAccountNumber);
    setIfscCode(details?.payOutIFSCNumber);
    setPanNumber(details?.payOutPanNumber);
    setPreview(true);
    setShowDetails(false);
    setShowInputs(true);
    setshow(true);
  };

  useEffect(() => {
    if (searchTerm == "") {
      setFilteredContacts(savedContacts);
    }
  }, [searchTerm, savedContacts]);

  const handlePayService = (contact) => {
    dispatch(
      setDetailsToSend({
        serviceName: "PayOut_Settlements",
        subService: "PayOut_Settlements",
      })
    );
    navigate("/ContactDetails", { state: { contact: contact } });
  };

  const handleConfirm = () => {
    setShowDetails(false);
    setshow(true);
  };

  const handleDeleteDetail = async (accountNo) => {
    const details = {
      payOutAccountNumber: accountNo,
      MerchantId: userDetails?.MerchantId,
      payOutActiveStatus: "DeActive",
      serviceName: "PayOut_Settlements",
    };
    try {
      const response = await Call_Api(
        path?.UPDATE_PAY_SERVICE_STATUS,
        "POST",
        details,
        token
      );
      await getAllPays();
    } catch (error) {
      console.log("error while updating the status ", error);
    }
  };

  const handilegoback = () => {
    setAccountNumber("");
    setBeneficiaryName("");
    setDetailsError("");
    setIfscCode("");
    setPanNumber("");
    setMobileNumber("");
    setAccountError("");
    setShowBeneficiaryInput(false);
    setIsIfscVerified(false);
    setIsIfscVerifying(false);
    setShowDetails(false);
    setShowInputs(false);
    setExistingError("");
    setAccountError("");
    setPanError("");
    setFilteredContacts(savedContacts);
  };

  if (
    userDetails?.walletStatus?.toLowerCase() !== "active" ||
    !userDetails?.allowWalletSettlements?.includes("PayOut_Settlements") ||
    !isFeatureActive(features, "PayOut_Settlements", "PayOut_Settlements")
  ) {
    return <Navigate to="/" />;
  }

  const handleDisable = () => {
    const isValid =
      accountNumber.length >= 10 &&
      ifscCode.length === 11 &&
      mobileNumber.length === 10 &&
      isIfscVerified &&
      (panNumber ? isPanVerified : true);
    return !isValid;
  };

  if (payLoading) {
    return <Loaders />;
  }

  return (
    <>
      <Header title="Pay" />
      <div
        className={`p-2 bg-white mx-4 rounded-4 d-flex justify-content-center pay_main_div_s ${
          !isFeatureServiceActive(
            features,
            "PayOut_Settlements",
            "PayOut_Settlements"
          )
            ? "disabled"
            : ""
        }`}
        style={{ height: "90vh", overflowY: "scroll", scrollbarWidth: "none" }}
      >
        {!isFeatureServiceActive(
          features,
          "PayOut_Settlements",
          "PayOut_Settlements"
        ) && (
          <div className="pay_active_service_s">
            <p className="error_service_down">{data?.seriveDown}</p>
          </div>
        )}

        <div style={{ scale: "0.89" }} className="w-40 pt-1">
          {showDetails ? (
            <div className="back_text">
              <KeyboardBackspaceIcon
                style={{ color: "var(--black)" }}
                fontSize="medium"
                onClick={() => {
                  handilegoback();
                }}
              />
              <p className="bank_details_heading_v">{data?.addPayee}</p>
            </div>
          ) : null}

          {!showInputs ? (
            <>
              <div>
                <div className="align-content-center ">
                  {savedContacts?.length > 0 ? (
                    <div className="search-add-container-v">
                      <div className="search-box-v">
                        <div className="search-icon-wrapper-v">
                          <SearchIcon className="search-icon-v" />
                        </div>
                        <input
                          type="text"
                          placeholder="Search for Payees"
                          onChange={(e) => handleSearch(e)}
                        />
                      </div>
                      <div className="add_button_div" title="Add New">
                        <button
                          className="btn btn-lg px-5 text-black"
                          style={{
                            display: "flex",
                            background: "none",
                            borderRadius: "2rem",
                            border: "1px solid #AAAAAA",
                            fontSize: "1rem",
                            width: "50px",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "0.2rem",
                          }}
                          onClick={() => {
                            setShowInputs(true);
                            setShowDetails(true);
                          }}
                        >
                          <AddIcon className="addicon-bg" />
                          {data?.add}
                        </button>
                      </div>
                    </div>
                  ) : filteredContacts?.length === 0 &&
                    savedContacts?.length === 0 ? (
                    <div>
                      <img
                        src={ImagesPath?.Payservice?.addpayee}
                        alt="addpayee"
                        width="80%"
                      />{" "}
                      <div className="add_button_div" title="Add New">
                        <button
                          className="btn btn-lg px-5 text-white"
                          style={{
                            backgroundColor: "var(--thirdshade-orange)",
                            borderRadius: "2rem",
                            fontSize: "1rem",
                          }}
                          onClick={() => {
                            setShowInputs(true);
                            setShowDetails(true);
                          }}
                        >
                          <span className="bi-plus-circle-fill"></span>{" "}
                          {data?.add}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="search-add-container-v">
                        <input
                          type="text"
                          className="form-control"
                          style={{
                            borderRadius: "2rem",
                            border: "1px solid #ccc",
                            padding: "8px 16px",
                            width: "100%",
                          }}
                          placeholder="Search for Payees"
                          onChange={(e) => handleSearch(e)}
                        />
                        <div className="add_button_div" title="Add New">
                          <button
                            className="btn btn-lg px-5 text-black"
                            style={{
                              display: "flex",
                              background: "none",
                              borderRadius: "2rem",
                              border: "1px solid #AAAAAA",
                              fontSize: "1rem",
                              width: "50px",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "0.2rem",
                            }}
                            onClick={() => {
                              setPanError("");
                              setShowInputs(true);
                              setShowDetails(true);
                            }}
                          >
                            <span
                              style={{
                                color: "var(--thirdshade-orange)",
                                width: "2rem",
                                height: "2rem",
                              }}
                              className="bi-plus-circle-fill"
                            ></span>{" "}
                            {data?.add}
                          </button>
                        </div>
                      </div>
                      <div>
                        <h2 className="text-center">{data?.NoPayee}</h2>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {filteredContacts.length === 0 || savedContacts?.length === 0 ? (
                <div className="no-contacts">
                  <p>{data?.NoPayee}</p>
                </div>
              ) : (
                <div className="contacts-list">
                  {filteredContacts.map((contact, index) => (
                    <div key={index} className="contact-card">
                      <div className="contact-initial">
                        {contact?.payOutName?.charAt(0)}
                      </div>
                      <div
                        className="contact-info"
                        // onClick={handleCardClick}
                        style={{ cursor: "pointer" }}
                        onClick={() => handlePayService(contact)}
                      >
                        <p className="contact-name">{contact.payOutName}</p>
                        <p className="contact-account">
                          <img
                            className="payeebank"
                            src={ImagesPath?.Payservice?.payeebank}
                          />
                          A/C: {contact?.payOutAccountNumber}
                        </p>
                      </div>

                      <div
                        onClick={() => {
                          handleShowDetail(contact);
                        }}
                      >
                        <i
                          style={{ fontSize: "1.2rem" }}
                          title="View Details"
                          className="bi bi-info-circle"
                        ></i>
                      </div>
                      <div>
                        <Popconfirm
                          title="Deleting Payee"
                          description="Are you sure to delete this Payee?"
                          icon={
                            <QuestionCircleOutlined
                              style={{ color: "var(--red)", fontSize: "1rem" }}
                            />
                          }
                          onConfirm={() =>
                            handleDeleteDetail(contact?.payOutAccountNumber)
                          }
                          okText="Yes"
                          cancelText="No"
                        >
                          <DeleteOutlineOutlinedIcon
                            titleAccess="Delete"
                            sx={{ fontSize: "1.5rem", color: "#FF0000" }}
                          />
                        </Popconfirm>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : null}

          {/* After Add pay is clicked */}
          {showDetails ? (
            <div className="pay-service_fields">
              <div className="payservice_input-fields">
                <div>
                  <div>
                    <div className="back_text">
                      {/* <KeyboardBackspaceIcon
                        style={{ color: "var(--black)" }}
                        fontSize="medium"
                        onClick={() => {
                          handilegoback();
                        }}
                      /> */}
                      {/* <p className="bank_details_heading_v">
                        Add Payee Details
                      </p> */}
                    </div>

                    <br />
                    {/* Account Number Field */}
                    <div className="input-wrapper">
                      <img
                        src={
                          accountNumber
                            ? ImagesPath?.POS?.orangeentername
                            : ImagesPath?.Payservice?.sidegrayprofile
                        }
                        alt="profile icon"
                      />
                      <label
                        htmlFor="accountNumber"
                        className={`input-label-v ${
                          accountNumber ? "filled" : ""
                        }`}
                      >
                        {data?.vendor}
                      </label>

                      <input
                        id="accountNumber"
                        type="text"
                        className="input-inside"
                        value={accountNumber}
                        onChange={(e) => {
                          const value = e.target.value;
                          setShowBeneficiaryInput(false);
                          setDetailsError("");
                          setIsIfscVerifying(false);
                          setIsIfscVerified(false);
                          setPanBeneficiaryName("");
                          setIsPanVerified(false);
                          setMobileNumber("");
                          setPanNumber("");
                          setPanError("");
                          // Allow only numbers
                          if (/^\d*$/.test(value)) {
                            setAccountError("");
                            setIsIfscVerifying(true);
                            setAccountNumber(value);
                          }
                        }}
                      />
                    </div>
                    <div className="input-wrapper">
                      <img
                        src={
                          ifscCode
                            ? ImagesPath?.Payservice?.orangeifsc
                            : ImagesPath?.Payservice?.Ifsc
                        }
                        alt="ifsc icon"
                      />
                      <label
                        htmlFor="ifscCode"
                        className={`input-label-v ${ifscCode ? "filled" : ""}`}
                      >
                        {data?.enterIfsc}
                      </label>
                      <input
                        id="ifscCode"
                        type="text"
                        className="input-inside"
                        value={ifscCode}
                        maxLength={11}
                        onChange={handleIfscChange}
                      />
                      {/* Displaying the verifying and verified badges */}
                      {isIfscVerifying &&
                        !isIfscVerified &&
                        ifscCode.length == 11 && (
                          <span
                            onClick={() => handleIfsc()}
                            className="verify-badge orange"
                          >
                            {isLoading ? (
                              <CircularProgress color="secondary" />
                            ) : (
                              "Verify"
                            )}
                          </span>
                        )}
                      {isIfscVerified && !isIfscVerifying && (
                        <span className="verify-badge green">
                          <i className="bi bi-check-circle-fill"></i>{" "}
                          {data?.verify}
                        </span>
                      )}
                    </div>
                    {accountError &&
                      accountNumber?.length > 0 &&
                      ifscCode?.length > 0 && (
                        <p className="error_pay_s">{accountError}</p>
                      )}
                    {/* Beneficiary Name Field */}
                    {showBeneficiaryInput && (
                      <>
                        {/* Beneficiary Name Field */}
                        <div className="input-wrapper">
                          <img
                            src={
                              beneficiaryName
                                ? ImagesPath?.Payservice?.orangeentername
                                : ImagesPath?.Payservice?.sidegrayprofile
                            }
                            alt="profile icon"
                          />
                          <label
                            htmlFor="beneficiaryName"
                            className={`input-label-v ${
                              beneficiaryName ? "filled" : ""
                            }`}
                          >
                            {data?.Beneficiary}
                          </label>
                          <input
                            id="beneficiaryName"
                            type="text"
                            className="input-inside"
                            value={beneficiaryName}
                            // onChange={handleBeneficiaryChange}
                          />
                        </div>

                        {/* PAN Number Field */}
                        <div className="input-wrapper">
                          <img
                            src={
                              mobileNumber
                                ? ImagesPath?.Payservice?.orangePan
                                : ImagesPath?.Payservice?.Pan
                            }
                            alt="profile icon"
                          />
                          <label
                            htmlFor="mobileNumber"
                            className={`input-label-v ${
                              mobileNumber ? "filled" : ""
                            }`}
                          >
                            {data?.vendorMobile}
                          </label>
                          <input
                            id="mobileNumber"
                            type="text"
                            maxLength={10} // Limit to 10 characters
                            className="input-inside"
                            value={mobileNumber}
                            onChange={handleMobileNumberChange} // Bind the change handler
                          />
                        </div>

                        {handleMessage(mobileNumber) && (
                          <p style={{ color: "red" }}>
                            {handleMessage(mobileNumber)}
                          </p>
                        )}

                        {/* PAN Number Field */}
                        <div className="input-wrapper">
                          <img
                            src={
                              panNumber
                                ? ImagesPath?.Payservice?.orangePan
                                : ImagesPath?.Payservice?.Pan
                            }
                            alt="profile icon"
                          />
                          <label
                            htmlFor="panNumber"
                            className={`input-label-v ${
                              panNumber ? "filled" : ""
                            }`}
                          >
                            {data?.vendorPan}
                          </label>
                          <input
                            id="panNumber"
                            type="text"
                            maxLength={10} // Limit to 10 characters
                            className="input-inside"
                            value={panNumber}
                            onChange={handlePanNumberChange} // Bind the change handler
                          />

                          {/* PAN Verification Section */}
                          {panNumber.length === 10 && !isPanVerified && (
                            <div>
                              <span
                                onClick={handlePanVerify}
                                className="verify-badge orange"
                              >
                                {isLoading ? (
                                  <CircularProgress color="secondary" />
                                ) : (
                                  "Verify PAN"
                                )}
                              </span>
                            </div>
                          )}

                          {/* Green Tick after PAN Verification */}
                          {isPanVerified && panNumber.length > 0 && (
                            <div className="verification-status">
                              <span className="verify-badge green">
                                <i className="bi bi-check-circle-fill"></i>{" "}
                                {data?.verify}
                              </span>
                            </div>
                          )}
                        </div>
                        {panBeneficiaryName ? (
                          <p className="ps-benficaryname">
                            {panBeneficiaryName}
                          </p>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    {panError ? <p className="error_pay_s">{panError}</p> : ""}
                    {detailsError ? (
                      <p className="error_pay_s">{detailsError}</p>
                    ) : (
                      ""
                    )}
                    {/* Buttons */}
                    <button
                      className="proceed-button_s"
                      onClick={handleConfirm}
                      disabled={
                        handleDisable() ||
                        isLoading ||
                        !/^[6-9]\d{0,9}$/.test(mobileNumber)
                      }
                    >
                      Proceed
                    </button>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {/* After Proceed Button */}
          {show && (
            <div>
              <div
                className="fw-medium fs-5 text-center"
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {preview ? (
                  ""
                ) : (
                  <KeyboardBackspaceIcon
                    onClick={() => {
                      setshow(false);
                      setShowDetails(true);
                      setShowInputs(true);
                      setExistingError("");
                      // setMobileNumber("");
                      // setBeneficiaryName("");
                      // setIfscCode("");
                      // setAccountNumber("");
                      // setPanNumber("");
                      // setPanBeneficiaryName("");
                      // setIsIfscVerified(false);
                      // setPanError("");
                    }}
                  />
                )}
                {data?.confirmD}
              </div>
              <div>
                <div className="text-center mt-3 pb-4">
                  <div className="d-flex justify-content-center align-items-center">
                    <img src={ImagesPath?.POS?.orangeentername} />
                    <div
                      style={{ color: "#113988", letterSpacing: "1px" }}
                      className="ms-2 fw-bold fs-5"
                    >
                      {beneficiaryName || "UserName"}
                    </div>
                  </div>
                </div>

                <div className="Linewith_coin">
                  <img
                    src={ImagesPath?.Payservice?.orange_icons}
                    alt="coin"
                    width={15}
                    className="coinImg"
                  />
                </div>

                <div>
                  <div className="d-flex justify-content-between">
                    <div className="text-start text-muted">
                      <div className="py-2">{data?.mobile}</div>
                      <div className="py-2">{data?.AccountNo}</div>
                      <div className="py-2">{data?.ifsc}</div>
                      <div className="py-2">{data?.pan}</div>
                    </div>
                    <div className="text-end">
                      <div className="py-2">
                        {mobileNumber || "Not Available"}
                      </div>

                      <div className="py-2">
                        {accountNumber || "Not Available"}
                      </div>
                      <div className="py-2">{ifscCode || "Not Available"}</div>
                      <div className="py-2">{panNumber || "Not Available"}</div>
                    </div>
                  </div>
                  {existingError ? (
                    <p className="error_pay_s">{existingError}</p>
                  ) : null}
                  <button
                    className="btn w-100 py-2 text-white rounded-5 mt-4"
                    style={{ backgroundColor: "var(--thirdshade-orange)" }}
                    disabled={addLoading}
                    onClick={() =>
                      handleProceed(preview ? "Preview" : "Confirm")
                    }
                  >
                    {preview ? "Preview OK!" : "Confirm"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
